import defaultImage from "../../assets/images/default.jpg";

const ImagePreviewModal = ({
  isOpen,
  onClose,
  image,
  fallbackImage = defaultImage,
}) => {
  if (!isOpen || !image) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.55)",
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          background: "#fff",
          padding: "10px",
          borderRadius: "4px",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.35)",
          maxWidth: "90vw",
          maxHeight: "85vh",
          display: "inline-flex",
        }}
      >
        <button
          type="button"
          aria-label="Close"
          onClick={onClose}
          style={{
            position: "absolute",
            top: "16px",
            right: "16px",
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            border: "none",
            background: "rgba(40, 40, 40, 0.85)",
            color: "#fff",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1,
            padding: 0,
            lineHeight: 1,
          }}
        >
          <i className="fa-solid fa-xmark" style={{ fontSize: "14px" }}></i>
        </button>
        <img
          src={image}
          alt="preview"
          style={{
            display: "block",
            maxWidth: "min(90vw, 520px)",
            maxHeight: "calc(85vh - 20px)",
            width: "auto",
            height: "auto",
            objectFit: "contain",
          }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = fallbackImage;
          }}
        />
      </div>
    </div>
  );
};

export default ImagePreviewModal;
